import { render, staticRenderFns } from "./product-create.vue?vue&type=template&id=4b59fa07&"
import script from "./product-create.vue?vue&type=script&lang=js&"
export * from "./product-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports